export default __webpack_public_path__ + "static/bodywork1-371d76de9574788bda39e35fa5c7342d.jpeg";